import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
} from '../../../../../ktor-ktor-client-core/io/ktor/client/request/HttpRequest.mjs';
import { Companion_getInstance12092dx8psw4e as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { header3kx6g3yb4df1r as header } from '../../../../../ktor-ktor-client-core/io/ktor/client/request/utils.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../okio-parent-okio/okio/Buffer.mjs';
import { PrimitiveClasses_getInstance6p7zmos9nw3c as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import {
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  NullBody_instanceoz9dr731l81q as NullBody_instance,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { HttpStatement3zxb33q8lku as HttpStatement } from '../../../../../ktor-ktor-client-core/io/ktor/client/statement/HttpStatement.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { isByteArray4nnzfn1x4o3w as isByteArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Builder1mo34du82b3c6 as Builder,
  HttpHeader1d7ldebjomr00 as HttpHeader,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import { flattenEntries2zw7fl55k6a0l as flattenEntries } from '../../../../../ktor-ktor-utils/io/ktor/util/StringValues.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { ApolloNetworkException3denf70pfh242 as ApolloNetworkException } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_HttpTimeout3mcrbvfnvmyx2 as get_HttpTimeout } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/HttpTimeout.mjs';
import { setReadTimeout12jih49pjfudm as setReadTimeout } from './KtorHttpEngine.js.mjs';
import { HttpClient3584jcajl7sef as HttpClient } from '../../../../../ktor-ktor-client-core/io/ktor/client/HttpClient.web.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  disposehycj9shx8d5q as dispose,
  HttpEngine345320iy1heif as HttpEngine,
} from '../../../../../apollo-kotlin-apollo-runtime/com/apollographql/apollo/network/http/HttpEngine.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_execute__d6syw1($this, request, $completion) {
  try {
    var tmp0 = $this.c6d_1;
    // Inline function 'io.ktor.client.request.request' call
    var urlString = request.q49_1;
    // Inline function 'io.ktor.client.request.request' call
    // Inline function 'kotlin.apply' call
    var this_0 = new (HttpRequestBuilder())();
    url(this_0, urlString);
    var tmp = this_0;
    var tmp_0;
    switch (request.p49_1.b2_1) {
      case 0:
        tmp_0 = Companion_getInstance().m50_1;
        break;
      case 1:
        tmp_0 = Companion_getInstance().n50_1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.s5g_1 = tmp_0;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = request.r49_1.u1();
    while (_iterator__ex2g4s.v1()) {
      var element = _iterator__ex2g4s.w1();
      header(this_0, element.d49_1, element.e49_1);
    }
    var tmp1_safe_receiver = request.s49_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      header(this_0, 'Content-Type', tmp1_safe_receiver.r47());
      var buffer = new (Buffer())();
      tmp1_safe_receiver.u47(buffer);
      // Inline function 'io.ktor.client.request.setBody' call
      var body = buffer.o3y();
      if (body == null) {
        this_0.u5g_1 = NullBody_instance;
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_1 = PrimitiveClasses_getInstance().gg();
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_2;
        try {
          tmp_2 = createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false);
        } catch ($p) {
          var tmp_3;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_3 = null;
          } else {
            throw $p;
          }
          tmp_2 = tmp_3;
        }
        var tmp$ret$2 = tmp_2;
        var tmp$ret$3 = new (TypeInfo())(tmp_1, tmp$ret$2);
        this_0.f5l(tmp$ret$3);
      } else {
        if (body instanceof OutgoingContent()) {
          this_0.u5g_1 = body;
          this_0.f5l(null);
        } else {
          this_0.u5g_1 = body;
          // Inline function 'io.ktor.util.reflect.typeInfo' call
          var tmp_4 = PrimitiveClasses_getInstance().gg();
          // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
          var tmp_5;
          try {
            tmp_5 = createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false);
          } catch ($p) {
            var tmp_6;
            if ($p instanceof Error) {
              var _unused_var__etf5q3_0 = $p;
              tmp_6 = null;
            } else {
              throw $p;
            }
            tmp_5 = tmp_6;
          }
          var tmp$ret$4 = tmp_5;
          var tmp$ret$5 = new (TypeInfo())(tmp_4, tmp$ret$4);
          this_0.f5l(tmp$ret$5);
        }
      }
    }
    // Inline function 'io.ktor.client.request.request' call
    var tmp_7 = (new (HttpStatement())(this_0, tmp0)).y5y($completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
    var response = tmp_7;
    // Inline function 'io.ktor.client.call.body' call
    var tmp_8 = response.r5i();
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_9 = PrimitiveClasses_getInstance().kg();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_10;
    try {
      tmp_10 = createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false);
    } catch ($p) {
      var tmp_11;
      if ($p instanceof Error) {
        var _unused_var__etf5q3_1 = $p;
        tmp_11 = null;
      } else {
        throw $p;
      }
      tmp_10 = tmp_11;
    }
    var tmp$ret$15 = tmp_10;
    var tmp$ret$16 = new (TypeInfo())(tmp_9, tmp$ret$15);
    var tmp_12 = tmp_8.o5i(tmp$ret$16, $completion);
    if (tmp_12 === get_COROUTINE_SUSPENDED())
      tmp_12 = yield tmp_12;
    var tmp_13 = tmp_12;
    var responseByteArray = (!(tmp_13 == null) ? isByteArray(tmp_13) : false) ? tmp_13 : THROW_CCE();
    var responseBufferedSource = (new (Buffer())()).b3z(responseByteArray);
    var tmp_14 = (new (Builder())(response.a5j().j53_1)).j49(responseBufferedSource);
    // Inline function 'kotlin.collections.map' call
    var this_1 = flattenEntries(response.l50());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().m2(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_0 = this_1.u1();
    while (_iterator__ex2g4s_0.v1()) {
      var item = _iterator__ex2g4s_0.w1();
      var tmp$ret$18 = new (HttpHeader())(item.bf_1, item.cf_1);
      destination.n2(tmp$ret$18);
    }
    return tmp_14.v48(destination).n37();
  } catch ($p) {
    if ($p instanceof CancellationException()) {
      var e = $p;
      throw e;
    } else {
      if ($p instanceof Error) {
        var t = $p;
        throw ApolloNetworkException().o47(t.message, t);
      } else {
        throw $p;
      }
    }
  }
}
var KtorHttpEngineClass;
function KtorHttpEngine() {
  if (KtorHttpEngineClass === VOID) {
    class $ {
      static e6d(client) {
        var $this = createThis(this);
        $this.c6d_1 = client;
        $this.d6d_1 = false;
        return $this;
      }
      static k6d(timeoutMillis) {
        timeoutMillis = timeoutMillis === VOID ? 60000n : timeoutMillis;
        return this.l6d(timeoutMillis, timeoutMillis);
      }
      static l6d(connectTimeoutMillis, readTimeoutMillis) {
        return this.e6d(HttpClient(($this$HttpClient) => {
          $this$HttpClient.n5h_1 = false;
          var tmp = get_HttpTimeout();
          $this$HttpClient.c5i(tmp, ($this$install) => {
            $this$install.b5u(connectTimeoutMillis);
            setReadTimeout($this$install, readTimeoutMillis);
            return Unit_instance;
          });
          return Unit_instance;
        }));
      }
      p67(request, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_execute__d6syw1.bind(VOID, this, request), $completion);
      }
      q6() {
        if (!this.d6d_1) {
          this.c6d_1.q6();
          this.d6d_1 = true;
        }
      }
    }
    protoOf($).vz = dispose;
    initMetadataForClass($, 'KtorHttpEngine', $.k6d, VOID, [HttpEngine()], [1]);
    KtorHttpEngineClass = $;
  }
  return KtorHttpEngineClass;
}
//region block: exports
export {
  KtorHttpEngine as KtorHttpEngine1d787w9ug90jw,
};
//endregion

//# sourceMappingURL=KtorHttpEngine.mjs.map
